"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const Card_1 = __importDefault(require("@material-ui/core/Card"));
const CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const CardHeader_1 = __importDefault(require("@material-ui/core/CardHeader"));
const styles_1 = require("@material-ui/core/styles");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useStyles = styles_1.makeStyles((theme) => ({
    wrapper: {
        margin: 0,
        boxShadow: `0px 16px 32px 0px #001E3C0A`,
        background: "white",
        display: "flex",
        flexDirection: "column",
        borderRadius: 8,
        overflow: "unset",
    },
    content: {
        padding: 32,
    },
    header: {
        padding: "32px !important",
        paddingBottom: "0 !important",
    },
    topBar: {
        borderTop: "5px solid #F5F5F5",
    },
}));
const Card = (_a) => {
    var { placeholder = (react_1.default.createElement(CircularProgress_1.default, { style: { margin: "auto" }, size: 60, color: "primary" })), topBar, header = "", children = "", className, style = {}, contentStyle = {}, isLoading } = _a, rest = __rest(_a, ["placeholder", "topBar", "header", "children", "className", "style", "contentStyle", "isLoading"]);
    const classes = useStyles();
    return (react_1.default.createElement(Card_1.default, Object.assign({ style: Object.assign({}, style), className: classnames_1.default(classes.wrapper, className, {
            [classes.topBar]: topBar,
        }) }, rest),
        header && (react_1.default.createElement(CardHeader_1.default, { className: classes.header, titleTypographyProps: { variant: "h2" }, title: header })),
        react_1.default.createElement(CardContent_1.default, { style: contentStyle, className: classes.content }, isLoading ? placeholder : children)));
};
exports.Card = Card;
//# sourceMappingURL=card.js.map